// src/componets/CryptoHeatmap.js
import React, { useEffect, useRef, memo } from 'react';

function CryptoHeatmap() {
  const container = useRef();

  useEffect(
    () => {
      const script = document.createElement("script");
      script.src = "https://s3.tradingview.com/external-embedding/embed-widget-crypto-coins-heatmap.js";
      script.type = "text/javascript";
      script.async = true;
      script.innerHTML = `
        {
          "dataSource": "Crypto",
          "blockSize": "market_cap_calc",
          "blockColor": "24h_close_change|5",
          "locale": "en",
          "symbolUrl": "",
          "colorTheme": "dark",
          "hasTopBar": true,
          "isDataSetEnabled": true,
          "isZoomEnabled": true,
          "hasSymbolTooltip": true,
          "isMonoSize": false,
          "width": "100%",
          "height": "100%"
        }`;
      
      let currentContainer = container.current;

      if (currentContainer) {
        const timeoutId = setTimeout(() => {
          currentContainer.appendChild(script);
        }, 100);

        return () => {
          clearTimeout(timeoutId);
          if (currentContainer) {
            currentContainer.innerHTML = "";
          }
        };
      }

      return () => {
        if (currentContainer) {
          currentContainer.innerHTML = "";
        }
      };
    }, []
  );

  return (
    <div className="tradingview-widget-container" ref={container}>
    </div>
  );
}

export default memo(CryptoHeatmap);
